import { render, staticRenderFns } from "./PerformacneFilter.vue?vue&type=template&id=23e373b0&scoped=true&"
import script from "./PerformacneFilter.vue?vue&type=script&lang=js&"
export * from "./PerformacneFilter.vue?vue&type=script&lang=js&"
import style0 from "./PerformacneFilter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PerformacneFilter.vue?vue&type=style&index=1&id=23e373b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e373b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VIcon,VTextField})
